import {
    FETCH_CC_META_DATA,
    FETCH_CC_META_DATA_ON_VIEW_CHANGE,
    FETCH_FILTER_DATA,
    ENABLE_GLOBAL_REFRESH,
    TOGGLE_GLOBAL_LOADER,
    TOGGLE_EDIT_MODE,
    WIDGET_LOADED,
    HANDLE_GLOBAL_COUNTRY,
    RESET_GLOBAL_COUNTRY,
    ENABLE_GLOBAL_REFRESH_WITH_DEEP_DIVE,
    FETCH_COLLECTIONS_LIST,
    RESET_TO_DEFAULT_ENABLED,
    TRANSLATED,
    RESET_TO_DEFAULT_DISABLED,
    SET_WIDGET_LOADERS,
    SAVE_GLOBAL_FILTER,
    RESET_GLOBAL_FILTER,
    SET_LAST_LANGUAGE,
    POST_MODAL_OPEN,
    POST_MODAL_CLOSED
} from "../actions/globalAction";
import { isFulfilled } from "./reducerUtils";

//set init global country
const getInitGlobalCountry = () => {
    let globalCountry = "jp";
    if (window.location.href.indexOf("feed") > -1) {
        const { globalCountries } = JSON.parse(sessionStorage.getItem("feedData"));
        globalCountry = globalCountries;
    } 
    return globalCountry;
}

const globalReducer = (
    state = {
        metaData: null,
        filterData: null,
        globalLoader: true,
        widgetLoaders: 6,
        globalRefresh: true,
        title: "",
        editMode: false,
        editModeSetting: {},
        globalCountries: "jp",
        collectionsList: null,
        selectedLanguage: "en",
        lastLanguage: null,
        resetToDefaultEnabled: false,
        postModalOpen: false,
        globalFilter: {},
        default_filter: {},
        globalFilterApplied: 0,
        ccId: null
    },
    action
) => {
    switch (action.type) {
        case isFulfilled(FETCH_CC_META_DATA):
            const darkMode = action.payload.dark_mode_enabled ? "dark" : "light";
            localStorage.setItem("darkMode", darkMode);
            document.getElementsByTagName("body")[0].setAttribute("data-theme", darkMode);
            const editMode = JSON.parse(action.payload.editMode);
            localStorage.setItem("filtersToBeRendered", action.payload.filters);
            localStorage.setItem("cc", JSON.stringify({ id: action.payload.id, title: action.payload.title }));
            const globalRefresh = action.payload.globalRefresh_enabled ? true : false
            return { ...state, globalRefresh, metaData: action.payload, title: action.payload.title, editMode: editMode.editMode, editModeSetting: editMode, globalFilter: action.payload.default_filter.filter_json, default_filter: action.payload.default_filter.filter_json, ccId: action.payload.id, globalCountries: getInitGlobalCountry()  };
        case isFulfilled(FETCH_CC_META_DATA_ON_VIEW_CHANGE):
            return { ...state, metaData: action.payload, globalCountries: 'jp',globalFilter: action.payload.default_filter.filter_json, default_filter: action.payload.default_filter.filter_json };
        case isFulfilled(FETCH_FILTER_DATA):
            return { ...state, filterData: action.payload };
        case TOGGLE_GLOBAL_LOADER:
            return { ...state, globalLoader: action.payload ? action.payload : !state.globalLoader };
        case WIDGET_LOADED:
            if (state.widgetLoaders > 1) {
                return { ...state, widgetLoaders: state.widgetLoaders - 1 }
            } else {
                return { ...state, globalRefresh: false, widgetLoaders: 0 }
            }
        case SET_WIDGET_LOADERS:
            return { ...state, widgetLoaders: action.payload }
        case RESET_TO_DEFAULT_ENABLED:
            return { ...state, resetToDefaultEnabled: true }
        case RESET_TO_DEFAULT_DISABLED:
            return { ...state, resetToDefaultEnabled: false }
        case ENABLE_GLOBAL_REFRESH:
            return { ...state, globalRefresh: true, widgetLoaders: action.payload };
        case ENABLE_GLOBAL_REFRESH_WITH_DEEP_DIVE:
            return { ...state, globalRefresh: true, widgetLoaders: 9 };
        case TOGGLE_EDIT_MODE:
            return { ...state, editMode: !state.editMode };
        case HANDLE_GLOBAL_COUNTRY:
            return { ...state, globalCountries: action.payload };
        case RESET_GLOBAL_COUNTRY:
            return { ...state, globalCountries: null };
        case isFulfilled(FETCH_COLLECTIONS_LIST):
            localStorage.setItem("collections", JSON.stringify(action.payload))
            return {
                ...state,
                collectionsList: action.payload
            }
        case TRANSLATED:
            return {
                ...state,
                selectedLanguage: action.payload,
            }
        case SET_LAST_LANGUAGE:
            return {
                ...state,
                lastLanguage: action.payload,
            }
        case SAVE_GLOBAL_FILTER:
            let filter = { duration: action.payload.duration, topics: action.payload.topics, subtopics: action.payload.subtopics };
            if(action.payload.duration==="custom"){
                if(action.payload.hasOwnProperty("start_date")) filter.start_date = action.payload.start_date
                if(action.payload.hasOwnProperty("end_date")) filter.end_date = action.payload.end_date
                if(action.payload.hasOwnProperty("rollingDate")) filter.rollingDate = action.payload.rollingDate
            }
            if (action.payload.themes && action.payload.themes.length > 0) {
                filter.themes = action.payload.themes;
            }
            if (action.payload.influencers && action.payload.influencers.length > 0) {
                filter.influencers = action.payload.influencers;
            }
            if (action.payload.platform && action.payload.platform.length > 0) {
                filter.platform = action.payload.platform;
            }
            if (action.payload.sentiment && action.payload.sentiment.length > 0) {
                filter.sentiment = action.payload.sentiment;
            }
            return{
                ...state,
                globalFilter: filter,
                globalFilterApplied: state.globalFilterApplied + 1
            }
        case RESET_GLOBAL_FILTER:
            return {
                ...state,
                globalFilterApplied: 0
            }
        case POST_MODAL_OPEN:
            return { ...state, postModalOpen: true }
        case POST_MODAL_CLOSED:
            return { ...state, postModalOpen: false }
        default:
            return state;
    }
};

export default globalReducer;
